import { PageHeader } from "../../page-header";
import { usePagamentoLote } from "../../../hooks/usePagamentoLote";
import { formatValueToMonetary } from "../../../utils/formatter";
import { Link } from "react-router-dom";
import { TbLayoutList } from "react-icons/tb";
import "../PagamentoLote.css";
import "./PagamentoLoteLotes.css";
import moment from "moment";

const BATCH_STATUS_LABELS = {
  RASCUNHO: "Rascunho",
  AGUARDANDO_APROVACAO: "Aguardando aprovação",
  EM_PROCESSAMENTO: "Em processamento",
  PAGO: "Pago",
  PARCIALMENTE_PAGO: "Parcialmente pago",
  COM_ALERTA: "Com alerta",
  FALHOU: "Falhou",
  REJEITADO: "Rejeitado",
};

function batchStatusBadgeClass(status) {
  const map = {
    RASCUNHO: "pendente",
    AGUARDANDO_APROVACAO: "pendente",
    EM_PROCESSAMENTO: "pendente",
    PAGO: "aprovado",
    PARCIALMENTE_PAGO: "alerta",
    COM_ALERTA: "alerta",
    FALHOU: "alerta",
    REJEITADO: "alerta",
  };
  return map[status] || "pendente";
}

export default function PagamentoLoteLotes() {
  const { batches, stats, submitBatch } = usePagamentoLote();

  return (
    <div className="paylote-page">
      <div className="paylote-inner col-md-10 m-auto mt-4">
        <div className="mb-3">
          <PageHeader
            title="Lotes"
            pages={[
              { name: "Pagamento em Lote", link: "/pagamento-lote/dashboard" },
              { name: "Lotes" },
            ]}
          />
        </div>

        {/* Summary metrics */}
        <section className="paylote-metrics paylote-lotes-metrics">
          <div className="paylote-metric-card">
            <div className="paylote-metric-icon blue"><TbLayoutList size={20} /></div>
            <div>
              <div className="paylote-metric-label">Total de lotes</div>
              <div className="paylote-metric-value">{batches.length}</div>
              <div className="paylote-metric-small">cadastrados</div>
            </div>
          </div>
          <div className="paylote-metric-card">
            <div className="paylote-metric-icon orange"><TbLayoutList size={20} /></div>
            <div>
              <div className="paylote-metric-label">Aguardando aprovação</div>
              <div className="paylote-metric-value">
                {batches.filter(b => b.status === "AGUARDANDO_APROVACAO").length}
              </div>
              <div className="paylote-metric-small">lotes abertos</div>
            </div>
          </div>
          <div className="paylote-metric-card">
            <div className="paylote-metric-icon green"><TbLayoutList size={20} /></div>
            <div>
              <div className="paylote-metric-label">Total aprovado</div>
              <div className="paylote-metric-value">{formatValueToMonetary(stats.approved.amount)}</div>
              <div className="paylote-metric-small">{stats.approved.count} contas</div>
            </div>
          </div>
        </section>

        {/* Batch table */}
        <section className="paylote-table-card">
          <div className="paylote-table-toolbar">
            <strong className="paylote-lotes-section-title">
              Todos os lotes
            </strong>
            <div className="paylote-search-area">
              <Link to="/pagamento-lote/novo" className="paylote-btn-primary" style={{ textDecoration: "none" }}>
                + Novo lote
              </Link>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>ID do lote</th>
                <th>Criado por</th>
                <th>Data de criação</th>
                <th>Contas</th>
                <th>Valor total</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch) => (
                <tr key={batch.id}>
                  <td><strong>#{batch.id}</strong></td>
                  <td>{batch.createdByName}</td>
                  <td className="paylote-lotes-date-cell">{moment(batch.createdAt, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</td>
                  <td>{batch.totalBills}</td>
                  <td><strong>{formatValueToMonetary(batch.totalAmount)}</strong></td>
                  <td>
                    <span className={`paylote-badge ${batchStatusBadgeClass(batch.status)}`}>
                      {BATCH_STATUS_LABELS[batch.status] || batch.status}
                    </span>
                  </td>
                  <td>
                    {batch.status === "RASCUNHO" && (
                      <button
                        className="paylote-lotes-approve-link"
                        onClick={() => submitBatch(batch.id)}
                        style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                      >
                        Submeter →
                      </button>
                    )}
                    {batch.status === "AGUARDANDO_APROVACAO" && (
                      <Link
                        to={`/pagamento-lote/aprovacao?batchId=${batch.id}`}
                        className="paylote-lotes-approve-link"
                      >
                        Aprovar →
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
